module.exports = __webpack_public_path__ + "static/media/chime.ee5ff930.mp3";